export default defineNuxtRouteMiddleware((to, from) => {
  const { navigateToLocalized } = useRouterUtils()
  const REDIRECT_ROUTE = `/forgot-password`
  const RESET_PASSWORD_ROUTE_NAME = 'reset-password'

  if (!from.path.includes(RESET_PASSWORD_ROUTE_NAME) && !to.query?.token)
    return navigateToLocalized(REDIRECT_ROUTE)
})
